module.exports = __webpack_public_path__ + "static/media/8022.e6b46b56.jpg";